<!-- @veltra/icons generated sha256:3bd9f277858a7ac2 gen:8 source:src/svg/normal/form-date-picker.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormDatePicker' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="12"
      height="11"
      x="2"
      y="3"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M2 7h12M5 1v3m6-3v3" />
    <circle cx="5" cy="9.5" r=".6" fill="currentColor" />
    <circle cx="8" cy="9.5" r=".6" fill="currentColor" />
    <circle cx="11" cy="9.5" r=".6" fill="currentColor" />
    <circle cx="5" cy="12" r=".6" fill="currentColor" />
  </svg>
</template>
